// Mock data for Infinitum Network Solutions Portfolio

export const companyInfo = {
  name: "INFINITUM",
  tagline: "NETWORK SOLUTIONS",
  description: "India's largest web series maker and biggest influence network in South India. With 500+ YouTube channels worldwide, 250+ brand partnerships, and cutting-edge AI solutions.",
  email: "contact@infinitumnetwork.in",
  website: "www.infinitumnetworksolutions.com",
  videoUrl: "https://customer-assets.emergentagent.com/job_48f1fe7d-2f7d-4a42-86b1-7c0cd9a5bea8/artifacts/8e8aea1c_Infinitum_Portfolio_Global_Digital_Network_Influencers_Production_Studio_Learning_Network_1080P.mp4",
  logoUrl: "https://customer-assets.emergentagent.com/job_my-portfolio-497/artifacts/rmv70e4t_Logo%20Transperent.png"
};

export const stats = [
  { label: "Brands Partnered", value: 250, suffix: "+" },
  { label: "Web Series Produced", value: 400, suffix: "+" },
  { label: "YouTube Channels", value: 500, suffix: "+" },
  { label: "Gold Play Buttons", value: 60, suffix: "+" },
  { label: "Silver Play Buttons", value: 150, suffix: "+" },
  { label: "Total Views", value: 10, suffix: "B+" }
];

export const services = [
  {
    id: 1,
    title: "Web Series Production",
    description: "India's largest web series maker with 400+ original productions across multiple languages and genres.",
    icon: "Film",
    stats: "400+ Web Series"
  },
  {
    id: 2,
    title: "YouTube Network",
    description: "Most awarded YouTube network managing 500+ channels globally with billions of views.",
    icon: "Youtube",
    stats: "500+ Channels"
  },
  {
    id: 3,
    title: "Infinitum News Network",
    description: "Premium news content featuring renowned journalists like Prabhu Chawla, Deepak Chaurasia, and more.",
    icon: "Newspaper",
    stats: "Top News Network"
  },
  {
    id: 4,
    title: "Infinitum Food Network",
    description: "Culinary excellence with top food creators like Tasty Teja and Rohith Pasupuleti.",
    icon: "UtensilsCrossed",
    stats: "1M+ Subscribers"
  },
  {
    id: 5,
    title: "Infinitum Music",
    description: "100+ original music videos across multiple languages featuring talented artists.",
    icon: "Music",
    stats: "100+ Music Videos"
  },
  {
    id: 6,
    title: "INFIAI - AI Solutions",
    description: "Cutting-edge AI services including chat bots, generative content, synthetic media, and AI voice-overs.",
    icon: "Brain",
    stats: "Next-Gen AI"
  }
];

export const creators = [
  {
    id: 1,
    name: "Tasty Teja",
    category: "Food Creator",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&h=400&fit=crop",
    subscribers: "834K",
    instagram: "tastyteja",
    youtube: "@TastyTeja",
    views: "120M"
  },
  {
    id: 2,
    name: "Rohith Pasupuleti",
    category: "Food Creator",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
    subscribers: "308K",
    instagram: "rohithpasupuleti",
    youtube: "@RohithPasupuleti",
    views: "45M"
  },
  {
    id: 3,
    name: "Prabhu Chawla",
    category: "News Anchor",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
    subscribers: "1.2M",
    instagram: "prabhuchawla",
    youtube: "@PrabhuChawla",
    views: "250M"
  },
  {
    id: 4,
    name: "Deepak Chaurasia",
    category: "News Anchor",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop",
    subscribers: "890K",
    instagram: "deepakchaurasia",
    youtube: "@DeepakChaurasia",
    views: "180M"
  },
  {
    id: 5,
    name: "Web Series Actor 1",
    category: "Actor",
    image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400&h=400&fit=crop",
    subscribers: "456K",
    instagram: "actor1",
    youtube: "@Actor1",
    views: "78M"
  },
  {
    id: 6,
    name: "Music Artist 1",
    category: "Music Artist",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop",
    subscribers: "567K",
    instagram: "musicartist1",
    youtube: "@MusicArtist1",
    views: "95M"
  },
  {
    id: 7,
    name: "Comedy Creator",
    category: "Content Creator",
    image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=400&fit=crop",
    subscribers: "723K",
    instagram: "comedycreator",
    youtube: "@ComedyCreator",
    views: "135M"
  },
  {
    id: 8,
    name: "Tech Reviewer",
    category: "Tech Creator",
    image: "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=400&h=400&fit=crop",
    subscribers: "645K",
    instagram: "techreviewer",
    youtube: "@TechReviewer",
    views: "110M"
  }
];

export const webSeries = [
  {
    id: 1,
    title: "AAS - Agent Anand Santosh",
    thumbnail: "https://images.unsplash.com/photo-1574267432644-f74f8ec55654?w=800&h=450&fit=crop",
    episodes: 12,
    views: "25M",
    rating: 4.5,
    description: "Action-packed thriller following Agent Anand Santosh",
    link: "#"
  },
  {
    id: 2,
    title: "Tamasha with Harsha",
    thumbnail: "https://images.unsplash.com/photo-1509281373149-e957c6296406?w=800&h=450&fit=crop",
    episodes: 8,
    views: "18M",
    rating: 4.2,
    description: "Comedy entertainment show with Harsha",
    link: "#"
  },
  {
    id: 3,
    title: "Detective Narda",
    thumbnail: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&h=450&fit=crop",
    episodes: 10,
    views: "22M",
    rating: 4.6,
    description: "Mystery thriller series featuring Detective Narda",
    link: "#"
  },
  {
    id: 4,
    title: "Berozgar Engineer",
    thumbnail: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&h=450&fit=crop",
    episodes: 15,
    views: "30M",
    rating: 4.7,
    description: "Comedy-drama about unemployed engineers",
    link: "#"
  },
  {
    id: 5,
    title: "The Audition Room",
    thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&h=450&fit=crop",
    episodes: 6,
    views: "15M",
    rating: 4.3,
    description: "Behind-the-scenes of casting and auditions",
    link: "#"
  },
  {
    id: 6,
    title: "Kisan Putra",
    thumbnail: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&h=450&fit=crop",
    episodes: 12,
    views: "20M",
    rating: 4.4,
    description: "Heartwarming story of a farmer's son",
    link: "#"
  }
];

export const youtubeChannels = [
  {
    id: 1,
    name: "Infinitum (Hindi)",
    language: "Hindi",
    subscribers: "8.88M",
    views: "3.6B",
    watchTime: "255M hrs",
    thumbnail: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Lagu Anak TV",
    language: "Indonesian",
    subscribers: "4.33M",
    views: "1.575B",
    watchTime: "88M hrs",
    thumbnail: "https://images.unsplash.com/photo-1551269901-5c5e14c25df7?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "O Mundo Das Crianças TV",
    language: "Portuguese",
    subscribers: "2.2M",
    views: "660M",
    watchTime: "45M hrs",
    thumbnail: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Studious",
    language: "Telugu",
    subscribers: "1.5M",
    views: "586.5M",
    watchTime: "25.1M hrs",
    thumbnail: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=400&fit=crop"
  },
  {
    id: 5,
    name: "Pambata TV",
    language: "Filipino",
    subscribers: "1.3M",
    views: "575M",
    watchTime: "32.5M hrs",
    thumbnail: "https://images.unsplash.com/photo-1596496050755-c923e73e42e1?w=400&h=400&fit=crop"
  },
  {
    id: 6,
    name: "Bolalar Qo'shiqlar",
    language: "Uzbek",
    subscribers: "1.3M",
    views: "537.5M",
    watchTime: "29.7M hrs",
    thumbnail: "https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=400&h=400&fit=crop"
  },
  {
    id: 7,
    name: "Edewcate (English)",
    language: "English",
    subscribers: "1.23M",
    views: "620M",
    watchTime: "295M hrs",
    thumbnail: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop"
  },
  {
    id: 8,
    name: "Детские песни",
    language: "Russian",
    subscribers: "1.2M",
    views: "630M",
    watchTime: "45M hrs",
    thumbnail: "https://images.unsplash.com/photo-1527689368864-3a821dbccc34?w=400&h=400&fit=crop"
  },
  {
    id: 9,
    name: "Edewcate (Gujarati)",
    language: "Gujarati",
    subscribers: "1.1M",
    views: "491M",
    watchTime: "12.1M hrs",
    thumbnail: "https://images.unsplash.com/photo-1533450718592-29d45635f0a9?w=400&h=400&fit=crop"
  }
];

export const clientLogos = [
  { name: "Sprite", logo: "https://via.placeholder.com/120x60/00ff00/ffffff?text=Sprite" },
  { name: "Mamaearth", logo: "https://via.placeholder.com/120x60/0066cc/ffffff?text=Mamaearth" },
  { name: "Country Delight", logo: "https://via.placeholder.com/120x60/ff6600/ffffff?text=Country+Delight" },
  { name: "Happn", logo: "https://via.placeholder.com/120x60/ff0066/ffffff?text=Happn" },
  { name: "G Square", logo: "https://via.placeholder.com/120x60/333333/ffffff?text=G+Square" },
  { name: "ASBL", logo: "https://via.placeholder.com/120x60/0099cc/ffffff?text=ASBL" },
  { name: "Brand 7", logo: "https://via.placeholder.com/120x60/9933cc/ffffff?text=Brand+7" },
  { name: "Brand 8", logo: "https://via.placeholder.com/120x60/cc6600/ffffff?text=Brand+8" }
];

export const globalLocations = [
  { city: "Hyderabad", country: "India", lat: 17.385, lng: 78.486 },
  { city: "Mumbai", country: "India", lat: 19.076, lng: 72.877 },
  { city: "Chennai", country: "India", lat: 13.082, lng: 80.270 },
  { city: "Paris", country: "France", lat: 48.856, lng: 2.352 },
  { city: "Zagreb", country: "Croatia", lat: 45.815, lng: 15.981 },
  { city: "Riyadh", country: "Saudi Arabia", lat: 24.713, lng: 46.675 },
  { city: "Dallas", country: "USA", lat: 32.776, lng: -96.796 },
  { city: "Dubai", country: "UAE", lat: 25.276, lng: 55.296 }
];
